
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    console.log('variant', variant)
    
    document.querySelector(`.Product__SlideshowNavImage[data-media-id="${variant?.featured_media?.id}"]`).click()
  });
$(document).ready(function(){
  $('.Product__Slideshow').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false, 
     fade: true,
     asNavFor: '.Product__SlideshowNavScroller',
      responsive: [
        {
          breakpoint: 1140,
          settings: {
            dots:true
          }
        }
      ]
  });

  $('.Product__SlideshowNavScroller').slick({
     slidesToShow: 6,
     slidesToScroll: 1,
     asNavFor: '.Product__Slideshow',
     arrows: false,
     focusOnSelect: true
  });

$('.new-featured-collection-section .ProductList-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '.new-featured-collection-section .slider-prev',
    nextArrow: '.new-featured-collection-section .slider-next',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots:true
        }
      }
    ]
}); 

  
function slider(){
   $('.product-innerdose-step .wrap-content').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.product-innerdose-step .slider-prev'),
    nextArrow: $('.product-innerdose-step .slider-next'),
    appendDots: $('.product-innerdose-step .reviews__dots'),
    customPaging : function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return '0' + (i + 1);
    },
     dotsClass: 'reviews__dots-list',
    });
 }
  
if($(window).width() < 768){
    slider();
}
window.addEventListener('resize', function(event) {
 if($(window).width() < 768){
   slider();
 } 
}, true);

$('.CollectionMain .ProductList--grid .Grid__Cell .product-addonInfo-slider').each(function() {
    var $status = $(this).siblings('.pagingInfo');
    var $slickElement = $(this);
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
  });  
    $slickElement.slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  });
  
$('.reviews-block .review-slider, .main-blog-posts .ArticleList').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
     adaptiveHeight: true,
     dots: true,
      prevArrow: $('.reviews-block .slider-prev, .main-blog-posts .slider-prev'),
      nextArrow: $('.reviews-block .slider-next, .main-blog-posts .slider-next'),
      appendDots: $('.reviews-block .reviews__dots, .main-blog-posts .reviews__dots'),
      customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '0' + (i + 1);
      },
       dotsClass: 'reviews__dots-list',
       responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2 
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true
          }
        }
      ]
    });

    $('.multiple-videos .multiple-video-blocks').slick({
    centerMode: true,
    centerPadding: '25%',
    slidesToShow: 1,
    focusOnSelect: true,
    dots: true,
    arrows: true,
    prevArrow: $('.multiple-videos .slider-prev'),
    nextArrow: $('.multiple-videos .slider-next'),
    appendDots: $('.multiple-videos .multi-dots'),
    customPaging : function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
        return '0' + (i + 1);
      },
    dotsClass: 'multi__dots-list',
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerPadding: '10%',
        }
      }
    ]
  });

 
  $(".ingredient-accordions .accordion-title").click(function(e){
    e.preventDefault();
    $(this).parent(".accordion-section").find(".accordion-main-content").slideToggle(300);
    $(this).parent(".accordion-section").prevAll(".accordion-section").find(".accordion-main-content").slideUp(300);
    $(this).parent(".accordion-section").nextAll(".accordion-section").find(".accordion-main-content").slideUp(300);
    if ($(this).hasClass("active")){
      $(this).removeClass("active");
    }else{
      $('.accordion-title').removeClass('active');
      $(this).addClass("active");
    }
  });
  
var rcWidgetLoaded = setInterval(function(){ 
 if($('.rc_container_wrapper').length > 0){
    clearInterval(rcWidgetLoaded);
      $('.rc-option__discount.rc_widget__option__discount').prepend('<span class="save-text">Save</span>')
      $('[data-label-text-subsave]').append('<br><span class="paid-mnth">Paid Monthly</span>')
      $('[data-label-text-onetime]').append('<br><span class="one-off">One Off Purchase</span>') 
    }
  },1000);  
    $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(500);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(500);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(500);
            $(this).children(".plusminus").text('-');
        }
        if ($(this).hasClass("active")){
          $(this).removeClass("active");
           }else{
          $('.accordion_head').removeClass('active');
          $(this).addClass("active");
    }
    });

$(document).on("click","body.template-collection .nutritional_panel img",function() {
    var GetImg = $(this).attr('src');
    $('body').append('<div class="supplement-modal"><button class="close-modal">&#x2715</button><img src="'+GetImg+'"/></div>')
    $('body').addClass('suplement-overflow-hidden');
});
$(document).on("click","body.template-collection .supplement-modal .close-modal",function() {
 $('.supplement-modal').remove();
 $('body').removeClass('suplement-overflow-hidden'); 
});


  $('section.main-faq-section .faq-inner .faq-accordion .faq-block .faq-qus.active + .faq-ans').slideDown(200)
  $(".faq-qus").on("click", function() {
    if($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".faq-ans").slideUp(200);
    }
    else {
      $(".faq-qus").removeClass("active");
      $(this).addClass("active");
      $(".faq-ans").slideUp(200);
      $(this).siblings(".faq-ans").slideDown(200);
    }
  }); 


$("body.template-product .all-main-btn:not('.ProductForm__AddToCart')").on("click",function(event){
   event.preventDefault();
    $('html,body').animate({scrollTop: $("form.ProductForm").offset().top},1000);
  });


})

$.getJSON('/cart.js', function(cart){ 
    var result = cart.item_count;
    console.log(result);
});


$('.grid-mob-slider.join-block .main-slide-block').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<img src="https://cdn.shopify.com/s/files/1/0716/9903/8484/files/Stroke-1_84073fff-1637-474e-a828-8a8aa518fdf9.png?v=1677657356" class="slider-left-arrow">',
  nextArrow:'<img src="//cdn.shopify.com/s/files/1/0716/9903/8484/files/Stroke-1.png?v=1677577333" class="slider-right-arrow">',
  
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        dots: true,
        adaptiveHeight: true,
      }
     },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        adaptiveHeight: true,
      }
     }
    ]
  });


// function AfterpayCustomCss(){
//   document.querySelector('square-placement').shadowRoot.querySelector('.afterpay-main-text').setAttribute('style', 'color:#fff');
// }

// var AfterpayInterval = setInterval(function () {
//   if($('square-placement').length){
//       AfterpayCustomCss();
//       clearInterval(AfterpayInterval);
//   }  
// }, 100);

$(document).ready(function(){
  $('body.landing-body .custom_button a, body.landing-body a.all-main-btn, body.landing-body .button_section a').on('click',function (e) {
      e.preventDefault();
     $('html,body').animate({scrollTop: $("body.landing-body .discount-product-container").offset().top},2000);
  });
  
  $(document).on("click",".product_supplement_wrap h3",function() {
    $('.product_supplement_wrap').addClass('active');
    $('body').addClass('supplement-open');
  });
  $(document).on("click",".product_supplement_wrap .close-btn",function() {
    $('.product_supplement_wrap').removeClass('active');
    $('body').removeClass('supplement-open');
  })

let height = $('.main-article-container').height() / 3.5;
  console.log(height, 'height')
if(jQuery(window).scrollTop() > height) {
    jQuery(".main-article-container .mobile-sticky-button").addClass('visible');
  }
  else{
    jQuery(".main-article-container .mobile-sticky-button").removeClass('visible');
  }

});

jQuery(window).on('scroll', function(){
  let height = $('.main-article-container').height() / 3.5;
  if(jQuery(window).scrollTop() > height){
    jQuery(".main-article-container .mobile-sticky-button").addClass('visible');
  }
  else{
    jQuery(".main-article-container .mobile-sticky-button").removeClass('visible');
  }
});

// compare price 
function comparePrice(price){
    let compare_price_div = $('.loop-subscription-compare-price');
    if(compare_price_div.length > 0){
        $(compare_price_div).text(price);
    }else{
        const newDiv = document.createElement("div");
        const newContent = document.createTextNode(price);
        newDiv.appendChild(newContent);
        newDiv.classList.add('loop-subscription-compare-price');
        $(newDiv).insertAfter('.loop-subscription-group-price-amount');
        $(newDiv).insertAfter('.loop-one-time-purchase-option-price-amount');
    }
}
let init_price = $('.SizeSwatch__Radio:checked').data('compare-price');
let single_price = $('body').data('product-compare-price');
if(init_price == null || init_price == 'undefined'){
   comparePrice(single_price);
}else{
 comparePrice(init_price);
}
$('.SizeSwatch__Radio').change(function(){
   let price = $(this).data('compare-price');
   comparePrice(price)
});

// end price